import React,{useContext,useEffect, useState, useRef, useMemo, useCallback} from 'react';
import { DatabaseContext } from '../../redux/DatabaseStore';
import { useFormik } from 'formik';
import { getRequest, postRequest ,deleteRequest, tabulatorGet} from '../../api/ApiController';
import { SaveIcon, AddIcon, CopyIcon, PrintIcon, VerticalLineIcon, BackToFirstIcon, BackIcon, ForwardIcon, ForwardToLastIcon, FavoriteIcon, PriceIcon, SaveAndCloseIcon, LoadPrioIcon, InfoIcon, ErrorIcon, TaskIcon, PermissionIcon, NeedIcon, EmergencyIcon,EditRowIcon, DeleteIcon, OutlookMsgIcon, BorrowItemIcon, UnseenIcon, SeenIcon, TechChangeIcon,EditIcon,CollapseTreeIcon,ExpandTreeIcon,BranchTreeIcon} from "../svg/svgIcons";
import { Dialog } from 'primereact/dialog';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import AuthContext from '../../components/AuthContext';
import { Splitter, SplitterPanel } from 'primereact/splitter';
import { ReactTabulator,reactFormatter } from 'react-tabulator';
import { DateTime } from "luxon";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css"
import '../../assets/css/style.css';
import '../../assets/css/iconsmenu.css';
import UtilContext from '../../components/UtilContext';
import { MaintenanceMaskDialogCheckbox } from '../../components/maintenance/MaintenanceMaskDialogCheckbox';
import { PanelMenu } from 'primereact/panelmenu';
import { Checkbox } from 'primereact/checkbox';
import { OverflowMenuProvider } from '../../components/toolbar/OverflowMenu';
import IntersectionObserverWrapper from '../../components/toolbar/IntersectionObserverWrap';
import ReactDOMServer from 'react-dom/server';
import { Avatar } from 'primereact/avatar';
import { getTimezone } from '../../utils/moduleSettings';
import { ExecutionDeadlineFormatter } from '../checklists/ChecklistExecutionDeadline';
import { createAsyncNavigateHandlers } from '../../utils/asyncArrayNavigate';
import { navigationContextToQueryParams } from '../../utils/maintenanceNavigationContext';
import {
  cleanSorters,
  createDedupedAjaxRequest,
  extractSafePaginationParams,
  refreshProgressiveFromStart,
  safeParse,
  mergePagedChecklistMachineDetailFiltersAndSorters,
  applyChecklistDetailColumnLayout,
  restoreChecklistDetailUserMaskToTable,
} from '../../utils/tabulatorProgressiveLoading';
import { getEffectiveMask } from '../../utils/effectiveMask';
import { getTabulatorPersistLayoutEvents } from '../../utils/tabulatorPersistLayout';
import {
  buildMaintenanceMaskAkcieSubItems,
  createConfirmSaveStandardMask,
  createConfirmApplyStandardLayoutToUserMask,
  createSaveUserMaskColumns,
  createOpenMaskDialog,
  createMaskSetFieldHandler,
  createMaskSelectAllHandler,
  createMaskDeselectAllHandler,
  hasApplicableStandardMaskRow,
  MAINTENANCE_MASK_DIALOG_SKIP_FIELDS,
} from '../../utils/maintenanceTabulatorMaskActions';
import { inputOnEnterHeaderFilter } from '../../utils/inputOnEnterHeaderFilter';
import { TABULATOR_LIST_ID_MIN_WIDTH } from '../../utils/tabulatorColumnMinWidth';
import {
  TABULATOR_AUDIT_PROFILES,
  buildAuditTabulatorColumns,
  mergeColumnVisibilityWithAuditDefaults,
} from '../../utils/tabulatorAuditColumns';
import { primeMultiSelectHeaderFilter } from '../../utils/primeMultiSelectHeaderFilter';
import { defaultProductLogoSrc } from '../../constants/brandingDisplay';
import {
  buildCanonicalPrintFooterHtml,
  buildCanonicalPrintHeaderHtml,
} from '../../utils/printChrome';
import { LocaleContext } from '../../components/LocaleContext';

const MASK_PAGE = 'MaintenanceCheckRecordDetail';

const CHECK_RECORD_DETAIL_COLUMN_FIELD_ORDER = Object.freeze([
  'rowSelection',
  'editor',
  'id',
  'template.name',
  'defined_id',
  'is_unread',
  'name',
  'custom_department',
  'user_update_at',
  'execution_deadline',
  'status',
  'process_status',
  'manager_name',
  'deadline',
  'manager_response',
  'manager_status',
  'checklist_status',
  'created_at',
  'updated_at',
]);

const DEFAULT_CHECK_RECORD_DETAIL_COLUMN_VISIBILITY = Object.freeze({
  rowSelection: true,
  editor: true,
  id: true,
  'template.name': true,
  defined_id: true,
  is_unread: true,
  name: true,
  custom_department: true,
  user_update_at: true,
  execution_deadline: true,
  status: true,
  process_status: true,
  manager_name: true,
  deadline: true,
  manager_response: true,
  manager_status: true,
  checklist_status: true,
  created_at: true,
  updated_at: true,
});

function mergeCheckRecordDetailColumnVisibilityFromSaved(saved) {
  return mergeColumnVisibilityWithAuditDefaults(DEFAULT_CHECK_RECORD_DETAIL_COLUMN_VISIBILITY, saved);
}

function applyCheckRecordDetailDataColumnVisibility(table, visibility) {
  if (!table) return;
  for (const field of Object.keys(DEFAULT_CHECK_RECORD_DETAIL_COLUMN_VISIBILITY)) {
    if (field === 'rowSelection' || field === 'editor') continue;
    if (visibility[field] === false) table.hideColumn?.(field);
    else table.showColumn?.(field);
  }
}

export default function MaintenanceCheckRecordDetail({machine, type, navigationContext}){

    const [state,dispatch] = useContext(DatabaseContext);
    const { t } = useContext(LocaleContext);
    const {setDialogText,setVisible,openFavoriteDialog,toast,setFastView,setUserMaskFilter,setStandardMaskFilter,getUserColor,getUserInitials,formatID,getDateFormat, openChosenNotificationPreferences} = useContext(UtilContext);
    const {user} = useContext(AuthContext);
    const canSetStandardMask = user?.permissions?.includes('set standard mask');
    const timezone = getTimezone(state?.module_settings || []);
    const dateFmt = getDateFormat?.(state?.module_settings) ?? 'dd.MM.yyyy';
    const dateTimeFmt = `${dateFmt} HH:mm`;

    const ref = useRef(null);
    const overlayRef = useRef(null);
    const inFlightRef = useRef({ sig: null, promise: null });
    const completedCacheRef = useRef(new Map());
    const tableBuiltRef = useRef(false);
    const isRestoringRef = useRef(false);
    const savedHScrollRef = useRef({ left: 0, pending: false });
    const getTable = useCallback(() => ref.current?.table ?? ref.current, []);
    const refreshFromStart = useCallback(() => refreshProgressiveFromStart(getTable, completedCacheRef, t('Common.LoadingData')), [getTable]);

    const [companyContactsList, setCompanyContactsList] = useState([]);
    const [companyContacts, setCompanyContacts] = useState([]);
    const [selectedRecord,setSelectedRecord] = useState(null);
    const effectiveCompanyContacts = (state.company_contacts || []).length ? (state.company_contacts || []) : companyContactsList;

    useEffect(() => {
        if ((state.company_contacts || []).length > 0) return;
        getRequest("/api/company_contacts?minimal=1&module=maintenance")
            .then((r) => { const list = r?.data ?? r ?? []; setCompanyContactsList(Array.isArray(list) ? list : []); })
            .catch(() => {});
    }, [state.company_contacts?.length]);

    const [columnsVisible, setColumnsVisible] = useState(() => ({ ...DEFAULT_CHECK_RECORD_DETAIL_COLUMN_VISIBILITY }));
    const [maskVisible, setMaskVisible] = useState(false);
    const [expandedKeys, setExpandedKeys] = useState({});
    const [formMachine,setFormMachine] = useState(machine);
    const currentMachineIdRef = useRef(machine?.id ?? null);
    const prevMachineIdRef = useRef(machine?.id);

    useEffect(() => {
        if (machine?.id != null) setFormMachine(machine);
    }, [machine?.id]);

    useEffect(() => {
        currentMachineIdRef.current = formMachine?.id ?? null;
    }, [formMachine?.id]);

    const pageSizePc = useMemo(() => {
        const v = (state.module_settings || []).find(s => s.module === 'global' && s.key === 'page_size_pc')?.value;
        const n = parseInt(v, 10);
        return (Number.isFinite(n) && n > 0) ? n : 50;
    }, [state.module_settings]);

    const buildRequestParams = useCallback((paramsFromTabulator = {}) => {
        const extra = {
            ...extractSafePaginationParams(paramsFromTabulator),
        };
        if (extra.size == null) extra.size = pageSizePc;
        const machineId = currentMachineIdRef.current;
        mergePagedChecklistMachineDetailFiltersAndSorters(extra, {
            getTable,
            tableBuiltForParams: tableBuiltRef.current,
            userMaskFilters: state.user_mask_filters,
            maskPage: MASK_PAGE,
            machineId: machineId ?? 0,
        });
        return extra;
    }, [pageSizePc, state.user_mask_filters, getTable]);

    const captureHScroll = useCallback(() => {
        const table = getTable();
        if (!table) return;
        const holder = table.rowManager?.element;
        if (!holder) return;
        savedHScrollRef.current = { left: holder.scrollLeft, pending: true };
    }, [getTable]);

    const restoreHScroll = useCallback(() => {
        if (!savedHScrollRef.current.pending) return;
        const table = getTable();
        if (!table) return;
        const holder = table.rowManager?.element;
        const header = table.columnManager?.contentsElement;
        if (!holder) return;
        const left = savedHScrollRef.current.left;
        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                holder.scrollLeft = left;
                if (header) header.scrollLeft = left;
                savedHScrollRef.current.pending = false;
            });
        });
    }, [getTable]);

    //TODO dorobit contractor id
    const [scrollIcons, setScrollIcons] = useState(false);
    const [editIcon,setEditIcon] = useState(true);
    const [deleteIcon,setDeleteIcon] = useState(true);

    const [visibleRecord,setVisibleRecord] = useState(false);
    const [images,setImages] = useState('');
    const [updatefileList, setUpdateFileList] = useState([]);
    const updateFileListRef = useRef(null);

    const onSelectRow = () => {
        setEditIcon(true);
        setDeleteIcon(true);
        const table = getTable();
        if (!table?.getSelectedData) return;
        if (table.getSelectedData().length > 0) {
            if (table.getSelectedData().length === 1) {
                if (user.permissions?.includes("edit maintenance")) setEditIcon(false);
            }
            if (user.permissions?.includes("delete maintenance")) setDeleteIcon(false);
        }
    };

    const validate = values => {
        const errors = {};
        /*if (!values.type) {
            errors.type = t('Common.RequiredField');
        }*/
        return errors;
    };

    function changeCompany(company_id){
        setCompanyContacts(effectiveCompanyContacts.filter(contact => contact.company_id == company_id));
        formikUpdate.setFieldValue('company_id',company_id);
        formikUpdate.setFieldValue('company_contact_id','');
        formikUpdate.setFieldValue("machines",[]);
    }

    function getRecordFiles(id){
        getRequest(`/api/maintenance_scheduled_records/protocols/${id}`).then((response) => {
            console.log(response);
            if(response.data!=="{}")setImages(response.data);
        });
    }

    useEffect(() => {
            // Update the document title using the browser API
        if(selectedRecord!=null){
            console.log(selectedRecord);
            console.log(formikUpdate.values);
            //getRecordFiles(selectedRecord.id);
        }
    },[selectedRecord]);

    const formikUpdate = useFormik({
        initialValues: selectedRecord ? 
            {id: selectedRecord?.id, maintenance_type_id: selectedRecord?.maintenance_type_id,
            last_execution_date:selectedRecord?.last_execution_date,description:selectedRecord?.description,
            company_id:selectedRecord?.company_id,company_contact_id:selectedRecord?.company_contact_id} : 
            {maintenance_type_id: '',last_execution_date: '',description:'',company_id:'',company_contact_id:''},
        enableReinitialize:true,
        validate,
        onSubmit: values => {
            let formData = new FormData();
            for (let value in values) {
                formData.append(value, values[value] != null ? values[value] : "");
            }
            for(let i = 0;i<updatefileList.length;i++){
                formData.append('files[]',updatefileList[i]);
            }
            postRequest(`/api/maintenance_scheduled_records/update/${formikUpdate.values.id}`, formData,true)
            .then((response) => {
                setVisibleRecord(false);
                formikUpdate.resetForm();
                if (updatefileList.length) {
                    setUpdateFileList([]);
                    if (updateFileListRef.current) updateFileListRef.current.value = null;
                }
                toast?.current?.show({ severity: 'info', summary: t('Common.Confirmed'), life: 3000, detail: t('Common.Toast.RecordSavedDetail') });
                if (formMachine?.id) {
                    getRequest(`/api/machine_cards/by_machine/${formMachine.id}`).then((r) => {
                        const d = r?.data?.data ?? r?.data;
                        if (d) setFormMachine(d);
                    }).catch(() => {});
                }
                getTable()?.replaceData?.();
            }).catch((reason) => {
                if(!navigator.online){
                    alert(t('ServiceTask.OfflineQueuedAlert'));
                }
                else{
                    alert(t('Common.Toast.ActionFailedDetail'));
                }
            });
        },
    });

    function hideEditRecord(){
        formikUpdate.resetForm();
        setVisibleRecord(false);
    }

    const resetDetailUiOnNavigate = useCallback(() => {
        setVisibleRecord(false);
        setSelectedRecord(null);
        setImages('');
        setUpdateFileList([]);
        if (updateFileListRef.current) updateFileListRef.current.value = null;
        setEditIcon(true);
        setDeleteIcon(true);
        setMaskVisible(false);
        formikUpdate.resetForm();
    }, [formikUpdate]);

    useEffect(() => {
        const prevId = prevMachineIdRef.current;
        const nextId = formMachine?.id;
        if (prevId === nextId) return;
        prevMachineIdRef.current = nextId;
        if (nextId == null || !tableBuiltRef.current) return;
        inFlightRef.current = { sig: null, promise: null };
        completedCacheRef.current.clear();
        captureHScroll();
        refreshFromStart();
    }, [formMachine?.id, captureHScroll, refreshFromStart]);

    const { scrollToFirst, scrollUp, scrollDown, scrollToLast } = useMemo(() => {
        const applyMachine = (data) => {
            if (!data) return;
            resetDetailUiOnNavigate();
            currentMachineIdRef.current = data.id ?? null;
            setFormMachine(data);
        };
        const buildFetchRecord = (toParams = () => '') => async (direction, currentId) => {
            setDialogText?.(t('Common.Loading'));
            setVisible?.(true);
            try {
                const q = toParams();
                const url = `/api/machines/navigate?direction=${direction}${currentId ? '&id=' + currentId : ''}${q ? '&' + q : ''}`;
                const resp = await getRequest(url);
                return resp?.data ?? null;
            } finally {
                setVisible?.(false);
            }
        };
        if (navigationContext?.filters != null || navigationContext?.sorters != null || navigationContext?.extra != null) {
            const toParams = () => navigationContextToQueryParams(navigationContext);
            return createAsyncNavigateHandlers(buildFetchRecord(toParams), applyMachine, () => currentMachineIdRef.current ?? formMachine?.id);
        }
        return createAsyncNavigateHandlers(buildFetchRecord(), applyMachine, () => currentMachineIdRef.current ?? formMachine?.id);
    }, [navigationContext, formMachine?.id, resetDetailUiOnNavigate, setDialogText, setVisible]);

    const accept = () => {
        const rows_to_delete = getTable()?.getSelectedData?.() ?? [];
        rows_to_delete.forEach(element => {
            deleteRequest(`/api/maintenance_scheduled_records/${element.id}`)
            .then((response) => {
                toast?.current?.show({ severity: 'info', summary: t('Common.Confirmed'), life: 3000, detail: t('Common.Toast.RecordDeletedDetail') });
            }).catch((reason) => {
                alert(reason);
                toast?.current?.show({ severity: 'warn', summary: t('Common.Rejected'), detail: t('Common.Toast.DeleteFailedDetail'), life: 3000 });
            });
        });
        if (formMachine?.id) {
            getRequest(`/api/machine_cards/by_machine/${formMachine.id}`).then((r) => {
                const d = r?.data?.data ?? r?.data;
                if (d) setFormMachine(d);
            }).catch(() => {});
        }
        getTable()?.replaceData?.();
    }
        
    const reject = () => {
        toast?.current?.show({ severity: 'warn', summary: t('Common.Rejected'), detail: t('Common.Toast.RequestCancelled'), life: 3000 });
    }

    const confirm = () => {
        confirmDialog({
            message: t('Common.ConfirmDeleteRecord'),
            header: t('Common.ConfirmDelete'),
            icon: 'pi pi-info-circle',
            acceptClassName: 'p-button-danger',
            acceptLabel: t('Common.Yes'),
            rejectLabel: t('Common.No'),
            accept,
            reject
        });
    };

    const acceptFile = (id) => {
        getRequest(`/api/maintenance_scheduled_records/deleteProtocol/${id}`)
        .then((response) => {
            toast?.current?.show({ severity: 'info', summary: t('Common.Confirmed'), life: 3000, detail: t('Common.Toast.FileDeletedDetail') });
            getRecordFiles(selectedRecord?.id);
        }).catch((reason) => {
            alert(reason);
            toast?.current?.show({ severity: 'warn', summary: t('Common.Rejected'), detail: t('Common.Toast.FileDeleteFailedDetail'), life: 3000 });
        })
    };

    function deleteFiles(img){
        confirmDialog({
            message: t('Common.ConfirmDeleteFile'),
            header: t('Common.ConfirmDelete'),
            icon: 'pi pi-info-circle',
            acceptClassName: 'p-button-danger',
            acceptLabel: t('Common.No'),
            rejectLabel: t('Common.Yes'),
            accept:reject,
            reject:() => acceptFile(img.id)
        });
    }

    function onEditRow(checklist_record){
      dispatch({type:'create_new_tab',name: t('Common.ChecklistRecord'), translationKey: 'Common.ChecklistRecord', legacyLabel: t('Common.ChecklistRecord'),page:'ChecklistRecordAllDetail',props:{checklist_record: checklist_record,type:'edit'},mask:'chck006'})
    };
    
    function EditRowFormatter(props) {
      const rowData = props.cell.getRow().getData();
      return <div className='flex items-center justify-center w-full h-full'><button type='button' onClick={() => onEditRow(rowData)}><EditRowIcon/></button></div>;
    }
    
    function removeDiacritics(str) {
        return (str || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    }
    
    const extractDepartmentsFromRecipients = (recipients) => {
          const departmentMap = new Map();
    
          recipients.forEach((user) => {
              const dept = user?.employee?.department;
              if (dept && !departmentMap.has(dept.id)) {
                departmentMap.set(dept.id, {
                    id: dept.id,
                    name: dept.name,
                    searchLabel: removeDiacritics(dept.name).toLowerCase(),
                });
              }
              else if(user?.employee?.department_id){
                let db_dept = state.departments.find(department => department.id == user?.employee?.department_id);
                departmentMap.set(db_dept.id, {
                    id: db_dept.id,
                    name: db_dept.name,
                    searchLabel: removeDiacritics(db_dept.name).toLowerCase(),
                });
              }
          });
    
          return Array.from(departmentMap.values());
      };
    
    function DepartmentFormatter(props) {
        const rowData = props.cell.getRow().getData();
        return extractDepartmentsFromRecipients([rowData?.user]).map(departmnent => departmnent?.name).join(', ');
    }
    
      function ManagerFormatter(props) {
        const rowData = props.cell.getRow().getData();
        if(rowData?.status === "NOK" && (rowData?.checklist_status || "").toLowerCase() !== "uzavretý")return "";
        const isBotCase = rowData?.status === "OK" && (rowData?.checklist_status || "").toLowerCase() === 'uzavretý';
        const timeToShow = isBotCase ? rowData?.user_update_at : rowData?.manager_update_at;
        return (
          <div className="flex items-center justify-start w-full h-full">
            {isBotCase ? (
              <div className="mr-2">
                <Avatar className='p-overlay-badge' title="System" icon="pi pi-database" shape="circle" style={{ backgroundColor: 'grey', color: '#ffffff',marginRight: '5px'}}/>
              </div>
            ) : (
              (rowData?.manager || rowData?.template?.manager) && (
                <div className='mr-2'>
                  <Avatar
                    title={rowData?.manager?.employee?.name || rowData?.manager?.username || rowData?.template?.manager?.employee?.name || rowData?.template?.manager?.username}
                    label={getUserInitials(rowData?.manager?.employee?.name || rowData?.manager?.username || rowData?.template?.manager?.employee?.name || rowData?.template?.manager?.username)}
                    shape="circle"
                    style={{
                      backgroundColor: getUserColor(rowData?.manager?.username || rowData?.template?.manager?.username),
                      color: "#ffffff",
                      marginRight: "5px",
                    }}
                  />
                </div>
              )
            )}
    
            {timeToShow && (
              <div>
                {/* ak máš SQL string */}
                {DateTime.fromSQL(timeToShow).toFormat(dateTimeFmt)}
              </div>
            )}
          </div>
        );
      }
    
        function IDRowFormatter(props) {
            const rowData = props.cell.getRow().getData();
            if(rowData?.id)return formatID("CHL-",3,rowData?.id);
            return t('Common.NotCreated');
        } 
        
        const processStatusOptions = [
          { label: t('Common.Created'), value: "Vytvorený" },
          { label: t('Common.InProgress'), value: "Rozpracovaný" },
          { label: t('Common.NotCreated'), value: "Nevytvorený" },
          { label: t('Common.InProgressOrNotCreated'), value: "Rozpracovaný,Nevytvorený" },
        ];
    
        function DeadlineFormatter(props) {
          const rowData = props.cell.getRow().getData();
          const baseDate = DateTime.fromISO(rowData.created_at);
          const deadline = baseDate.plus({ days: rowData.template.manager_due_days }).startOf("day");
          const now = DateTime.now().setZone(timezone);
    
          // Dátum vyjadrenia (použi reálne pole, ktoré u vás znamená "vyjadrené")
          // Dávam viac možností, aby to fungovalo aj keď je názov iný.
          const expressedAtIso = rowData?.manager_update_at || null;
          const expressedTmp = expressedAtIso ? DateTime.fromISO(expressedAtIso) : null;
          const expressedAt = expressedTmp?.isValid ? expressedTmp : null;
    
          // ak je vyjadrené po deadline => červené
          const isLateExpression = !!(expressedAt && expressedAt > deadline);
    
          // ak ešte nie je vyjadrené a deadline prešiel => červené
          const isExpiredAndNotExpressed = !expressedAt && now > deadline;
    
          const isRed = (isLateExpression || isExpiredAndNotExpressed) && rowData?.status !== "OK";
    
          const managerName =
            rowData?.manager?.employee?.name ||
            rowData?.manager?.username ||
            rowData?.template?.manager?.employee?.name ||
            rowData?.template?.manager?.username ||
            "";
    
          const managerUsername =
            rowData?.manager?.username ||
            rowData?.template?.manager?.username ||
            "";
    
          return (
            <div className="flex items-center justify-start w-full h-full">
              {(rowData?.manager || rowData?.template?.manager) && (
                <div className='mr-2'>
                  <Avatar
                    title={managerName}
                    label={getUserInitials(managerName)}
                    shape="circle"
                    style={{
                      backgroundColor: getUserColor(managerUsername),
                      color: "#ffffff",
                      marginRight: "5px",
                    }}
                  />
                </div>
              )}
              {/* Deadline vyjadrenia nechávame vždy zobrazovať, aj po vyjadrení */}
              <div
                  className={`${
                    isRed ? "text-red-600 font-semibold" : ""
                  }`}
                >
                  {deadline.toFormat(dateFmt)}
                </div>
            </div>
          );
        }
    
        function UserUpdateFormatter(props) {
            const rowData = props.cell.getRow().getData();
            // RAW API process_status tokens — do not localize
            if (rowData?.process_status === 'Nevytvorený' || rowData?.process_status === 'Rozpracovaný') return;
            return <div className='flex items-center justify-start w-full h-full'>
                {rowData?.user && <div><Avatar title={rowData?.user?.employee?.name || rowData?.user?.username} label={getUserInitials(rowData?.user?.employee?.name || rowData?.user?.username)} shape="circle" style={{ backgroundColor: getUserColor(rowData?.user?.username), color: '#ffffff',marginRight: '5px'}} /></div>}
                <div>{DateTime.fromSQL(rowData.user_update_at).toFormat(dateTimeFmt)}</div>
            </div>;
        }
    
        const markAsViewed = async (recordId, value) => {
          const formData = new FormData();
          formData.append("record_id", recordId);
          formData.append("user_id", user.id);
          const url = !value
            ? `/api/checklist_records/${recordId}/mark-as-viewed`
            : `/api/checklist_records/${recordId}/mark-as-not-viewed`;
          try {
            await postRequest(url, formData, true);
            dispatch({ type: "updateRecordViewed", payload: recordId, value: value });
          } catch (err) {
            // fallback, nech sa UI zosynchronizuje
            //dispatch({ type: "updateRecordViewed", payload: recordId, value: value });
          }
        };
    
        
      function MailIconTemplate(props) {
        const rowData = props.cell.getRow().getData();
        if (rowData?.manager_response || rowData?.comments?.length > 0) {
          const isUnread = rowData?.is_unread;
    
          return (
            <div className="flex items-center gap-2">
              {isUnread ? (
                <button type="button" title={t('Common.MarkAsRead')} onClick={() => markAsViewed(rowData.id, false)} className="hover:opacity-75">
                  <UnseenIcon />
                </button>
              ) : (
                <button type="button" title={t('Common.MarkAsUnread')} onClick={() => markAsViewed(rowData.id, true)} className="hover:opacity-75">
                  <SeenIcon />
                </button>
              )}
            </div>
          );
        }
        return "";
      }

    const remoteHeaderFilter = useCallback(() => true, []);

    const checklistAuditTailColumns = useMemo(() => {
        return buildAuditTabulatorColumns({
            profile: TABULATOR_AUDIT_PROFILES.checklistCreatorLastTouched,
            includeId: false,
            dateFormat: dateFmt,
            dateTimeFormat: dateTimeFmt,
            getUserColor,
            getUserInitials,
            textHeaderFilter: remoteHeaderFilter,
            remotePassthrough: true,
        });
    }, [dateFmt, dateTimeFmt, getUserColor, getUserInitials, remoteHeaderFilter]);

    const columns = useMemo(
        () => [
            {
                formatter: 'rowSelection',
                titleFormatter: 'rowSelection',
                field: 'rowSelection',
                hozAlign: 'center',
                width: 44,
                minWidth: 44,
                headerSort: false,
                frozen: true,
                print: false,
                download: false,
            },
            {
                title: '',
                field: 'editor',
                hozAlign: 'center',
                width: 44,
                minWidth: 44,
                headerSort: false,
                formatter: reactFormatter(<EditRowFormatter />),
                resizable: false,
                frozen: true,
                print: false,
                download: false,
            },
            {
                title: 'ID',
                field: 'id',
                headerFilter: inputOnEnterHeaderFilter,
                headerFilterLiveFilter: false,
                headerFilterFunc: remoteHeaderFilter,
                minWidth: TABULATOR_LIST_ID_MIN_WIDTH,
                widthGrow: 1,
                sorter: 'number',
                hozAlign: 'left',
            },
            {
                title: t('Common.Name'),
                field: 'template.name',
                headerFilter: inputOnEnterHeaderFilter,
                headerFilterLiveFilter: false,
                headerFilterFunc: remoteHeaderFilter,
                minWidth: 200,
            },
            {
                title: t('Common.ChecklistNumber'),
                field: 'defined_id',
                formatter: reactFormatter(<IDRowFormatter />),
                headerFilter: inputOnEnterHeaderFilter,
                headerFilterLiveFilter: false,
                headerFilterFunc: remoteHeaderFilter,
                minWidth: 100,
                widthGrow: 1,
            },
            {
                title: t('Common.Read'),
                field: 'is_unread',
                minWidth: 100,
                resizable: false,
                formatter: reactFormatter(<MailIconTemplate />),
                headerFilter: primeMultiSelectHeaderFilter,
                headerFilterParams: {
                    placeholder: t('Common.All'),
                    valueType: 'string',
                    options: [
                        { label: t('Common.Unread'), value: 'true' },
                        { label: t('Common.Read'), value: 'false' },
                    ],
                },
                headerFilterFunc: remoteHeaderFilter,
            },
            {
                title: t('Common.Description'),
                field: 'name',
                headerFilter: inputOnEnterHeaderFilter,
                headerFilterLiveFilter: false,
                headerFilterFunc: remoteHeaderFilter,
                minWidth: 190,
            },
            {
                title: t('Common.Department'),
                field: 'custom_department',
                headerFilter: inputOnEnterHeaderFilter,
                headerFilterLiveFilter: false,
                headerFilterFunc: remoteHeaderFilter,
                minWidth: 190,
                formatter: reactFormatter(<DepartmentFormatter />),
            },
            {
                title: t('Common.CompletionDate'),
                field: 'user_update_at',
                minWidth: 230,
                formatter: reactFormatter(<UserUpdateFormatter />),
                headerFilter: inputOnEnterHeaderFilter,
                headerFilterLiveFilter: false,
                headerFilterFunc: remoteHeaderFilter,
            },
            {
                title: t('Common.CompletionDeadline'),
                field: 'execution_deadline',
                minWidth: 230,
                formatter: reactFormatter(<ExecutionDeadlineFormatter />),
                headerFilter: inputOnEnterHeaderFilter,
                headerFilterLiveFilter: false,
                headerFilterFunc: remoteHeaderFilter,
            },
            {
                title: t('Common.Status'),
                field: 'status',
                minWidth: 100,
                headerFilter: primeMultiSelectHeaderFilter,
                headerFilterParams: {
                    placeholder: t('Common.All'),
                    valueType: 'string',
                    options: [
                        { label: 'OK', value: 'OK' },
                        { label: 'NOK', value: 'NOK' },
                    ],
                },
                headerFilterFunc: remoteHeaderFilter,
            },
            {
                title: t('Common.ProcessStatus'),
                field: 'process_status',
                minWidth: 160,
                headerFilter: primeMultiSelectHeaderFilter,
                headerFilterParams: {
                    placeholder: t('Common.All'),
                    valueType: 'string',
                    options: processStatusOptions.map((o) => ({ label: o.label, value: o.value })),
                },
                headerFilterFunc: remoteHeaderFilter,
            },
            {
                title: t('Common.StatementDate'),
                field: 'manager_name',
                minWidth: 200,
                formatter: reactFormatter(<ManagerFormatter />),
                headerFilter: inputOnEnterHeaderFilter,
                headerFilterLiveFilter: false,
                headerFilterFunc: remoteHeaderFilter,
            },
            {
                title: 'Deadline vyjadrenia',
                field: 'deadline',
                minWidth: 210,
                formatter: reactFormatter(<DeadlineFormatter />),
                headerFilter: inputOnEnterHeaderFilter,
                headerFilterLiveFilter: false,
                headerFilterFunc: remoteHeaderFilter,
            },
            {
                title: 'Vyjadrenie',
                field: 'manager_response',
                headerFilter: inputOnEnterHeaderFilter,
                headerFilterLiveFilter: false,
                headerFilterFunc: remoteHeaderFilter,
                minWidth: 200,
                widthGrow: 1,
            },
            {
                title: t('Common.StatementStatus'),
                field: 'manager_status',
                headerFilter: inputOnEnterHeaderFilter,
                headerFilterLiveFilter: false,
                headerFilterFunc: remoteHeaderFilter,
                minWidth: 200,
                widthGrow: 1,
            },
            {
                title: t('Common.ChecklistStatus'),
                field: 'checklist_status',
                headerFilter: inputOnEnterHeaderFilter,
                headerFilterLiveFilter: false,
                headerFilterFunc: remoteHeaderFilter,
                minWidth: 200,
                widthGrow: 1,
            },
            ...checklistAuditTailColumns,
        ],
        [checklistAuditTailColumns, remoteHeaderFilter, processStatusOptions]
    );

      const itemRenderer = (item, options) => (
        <a className="flex align-items-center px-3 py-2 cursor-pointer items-center bg-[#333] text-white w-[180px]" onClick={options.onClick}>
            <span className={`${item.icon} text-primary`} />
            <span className={`mx-2 ${item.items && 'font-semibold'}`}>{item.label}</span>
            {item.shortcut && <span className="ml-auto border-1 surface-border border-round surface-100 text-xs p-1">{item.shortcut}</span>}
        </a>
      );
    
      const closeMenu = useCallback(() => {
        setTimeout(() => {
          OverflowMenuProvider.setVisible?.(null);
          setExpandedKeys({});
        }, 0);
      }, []);

      const hasApplicableStandardMask = useMemo(
        () => hasApplicableStandardMaskRow(state.standard_mask_filters, MASK_PAGE, mergeCheckRecordDetailColumnVisibilityFromSaved),
        [state.standard_mask_filters]
      );

      const openMaskDialog = useCallback(
        createOpenMaskDialog({
          columnsVisible,
          setColumnsVisible,
          defaultColumnVisibility: DEFAULT_CHECK_RECORD_DETAIL_COLUMN_VISIBILITY,
          mergeVisibilityFromSaved: mergeCheckRecordDetailColumnVisibilityFromSaved,
          setMaskVisible,
          closeMenu,
        }),
        [columnsVisible, closeMenu]
      );

      const saveUserMaskColumns = useCallback(
        createSaveUserMaskColumns({
          maskPage: MASK_PAGE,
          getTable,
          setUserMaskFilter,
          defaultColumnVisibility: DEFAULT_CHECK_RECORD_DETAIL_COLUMN_VISIBILITY,
          columnsVisible,
          setColumnsVisible,
          setMaskVisible,
          toast,
        }),
        [columnsVisible, getTable, setUserMaskFilter, toast]
      );

      const confirmSaveStandardMask = useCallback(
        createConfirmSaveStandardMask({
          maskPage: MASK_PAGE,
          getTable,
          setStandardMaskFilter,
          defaultColumnVisibility: DEFAULT_CHECK_RECORD_DETAIL_COLUMN_VISIBILITY,
          toast,
        }),
        [getTable, setStandardMaskFilter, toast]
      );

      const confirmApplyStandardLayoutToUserMask = useCallback(
        createConfirmApplyStandardLayoutToUserMask({
          maskPage: MASK_PAGE,
          state,
          setUserMaskFilter,
          defaultColumnVisibility: DEFAULT_CHECK_RECORD_DETAIL_COLUMN_VISIBILITY,
          mergeVisibilityFromSaved: mergeCheckRecordDetailColumnVisibilityFromSaved,
          toast,
          closeMenu,
          onAppliedToTable: ({ colsForSave, attributes }) => {
            const table = getTable();
            if (!table) return;
            isRestoringRef.current = true;
            applyChecklistDetailColumnLayout(table, attributes, CHECK_RECORD_DETAIL_COLUMN_FIELD_ORDER);
            applyCheckRecordDetailDataColumnVisibility(table, colsForSave);
            setColumnsVisible(colsForSave);
            setTimeout(() => {
              isRestoringRef.current = false;
              captureHScroll();
              refreshFromStart();
            }, 0);
          },
        }),
        [state, closeMenu, getTable, setUserMaskFilter, toast, captureHScroll, refreshFromStart]
      );

      const setMask = useCallback(
        createMaskSetFieldHandler({
          defaultColumnVisibility: DEFAULT_CHECK_RECORD_DETAIL_COLUMN_VISIBILITY,
          columnsVisible,
          setColumnsVisible,
          getTable,
          applyVisibilityToTable: applyCheckRecordDetailDataColumnVisibility,
          toast,
        }),
        [columnsVisible, getTable, toast]
      );

      const maskSelectAll = useCallback(
        createMaskSelectAllHandler({
          defaultColumnVisibility: DEFAULT_CHECK_RECORD_DETAIL_COLUMN_VISIBILITY,
          setColumnsVisible,
          getTable,
          applyVisibilityToTable: applyCheckRecordDetailDataColumnVisibility,
        }),
        [getTable]
      );

      const maskDeselectAll = useCallback(
        createMaskDeselectAllHandler({
          defaultColumnVisibility: DEFAULT_CHECK_RECORD_DETAIL_COLUMN_VISIBILITY,
          setColumnsVisible,
          getTable,
          applyVisibilityToTable: applyCheckRecordDetailDataColumnVisibility,
        }),
        [getTable]
      );

      const handleClickOutside = (event) => {
        if (event.target.closest('[data-overflow-trigger]')) return;
        if (overlayRef.current && !overlayRef.current.contains(event.target)) {
            setExpandedKeys({});
            OverflowMenuProvider.setVisible?.(null);
        }
      };

      useEffect(() => {
        document.addEventListener('click', handleClickOutside, true);
        return () => document.removeEventListener('click', handleClickOutside, true);
      }, []);

    useEffect(() => {
        const handler = () => { refreshFromStart(); };
        window.addEventListener("checklist_all_records:updated", handler);
        return () => window.removeEventListener("checklist_all_records:updated", handler);
    }, [refreshFromStart]);

      const items = [
      {
        key: '0',
        label: t('Common.Actions'),
        icon: 'pi pi-sliders-v',
        template: itemRenderer,
        items: buildMaintenanceMaskAkcieSubItems({
          maskPage: MASK_PAGE,
          getTable,
          setUserMaskFilter,
          cleanSorters,
          captureHScroll,
          refreshFromStart,
          closeMenu,
          openMaskDialog,
          openChosenNotificationPreferences,
          hasApplicableStandardMask,
          confirmApplyStandardLayoutToUserMask,
          itemRenderer,
        }),
      }
    ];

    return ( 
        <>
            <div>
            <div className='w-full h-10 flex flex-row bg-[#333]'>
            <IntersectionObserverWrapper>
            <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="edit"><button className="disabled:opacity-25" disabled={editIcon} onClick={() => {getRecordFiles(selectedRecord?.id);setVisibleRecord(true);}}><EditIcon/></button></div>
            <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="delete"><button className="disabled:opacity-25" onClick={confirm} disabled={deleteIcon}><DeleteIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center ' data-targetid="print"><button type="button" onClick={() => getTable()?.print?.(false, true)}><PrintIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="vert"><VerticalLineIcon/></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="first"><button className="disabled:opacity-25" onClick={() => scrollToFirst()} disabled={scrollIcons}><BackToFirstIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="back"><button className="disabled:opacity-25" onClick={() => scrollUp()} disabled={scrollIcons}><BackIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="forward"><button className="disabled:opacity-25" onClick={() => scrollDown()} disabled={scrollIcons}><ForwardIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="last"><button className="disabled:opacity-25" onClick={() => scrollToLast()} disabled={scrollIcons}><ForwardToLastIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="vert"><VerticalLineIcon/></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="favorite"><button className="disabled:opacity-25" disabled onClick={() => openFavoriteDialog(t('Maintenance.MachineChecklists'),"MaintenanceCheckRecordDetail")}><FavoriteIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="price"><button className="disabled:opacity-25" disabled onClick={() => setFastView("MaintenanceCheckRecordDetail",columnsVisible,columns)}><PriceIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="vert"><VerticalLineIcon/></div>
          {canSetStandardMask ? (
            <div className="flex w-10 h-10 px-2 py-1 justify-center" data-targetid="save-standard-mask">
              <button type="button" title={t('Common.SaveStandardMask')} aria-label={t('Common.SaveStandardMask')} onClick={confirmSaveStandardMask} className="flex items-center justify-center">
                <i className="pi pi-bookmark text-white text-xl" aria-hidden="true" />
              </button>
            </div>
          ) : null}
          <div className="card flex justify-content-center z-[100]" data-targetid="actions" ref={overlayRef}>
            <PanelMenu model={items} expandedKeys={expandedKeys} onExpandedKeysChange={setExpandedKeys} className="w-full md:w-20rem"/>
          </div>
          </IntersectionObserverWrapper>
        </div>
        <Splitter className='h-[calc(100vh_-_177px)]' layout="vertical" pt={{ gutter: { className: 'bg-[#333] h-8' },gutterHandler: { className: 'bg-secondary ' } }}>
    <SplitterPanel className="flex align-items-center justify-content-center overflow-y-auto " minSize={20} size={25}>
            <div className="w-full relative flex flex-col overflow-x">
              <div className='xl:grid grid-cols-2 gap-1 mb-2'>
              <div className="w-auto p-6 m-4 bg-gray-100 rounded-md shadow-md">
                    <h1 className="text-3xl font-semibold text-left text-zinc-900">
                       CHECKLISTY STROJA
                    </h1>
                    <label className="block text-md font-semibold text-gray-800">Por.č.: {formMachine?.id}</label>
                    <div className="mt-6">
                        <div className="md:grid grid-cols-2 gap-2 mb-2">
                            <div>
                                <label
                                    htmlFor="name"
                                    className="block text-md font-semibold text-gray-800"
                                >{t('Common.MachineName')}</label>
                                <input
                                    name='name'
                                    type="text"
                                    readOnly value={formMachine?.name}
                                    className="block w-full  px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                                />
                            </div>
                            <div>
                                <label
                                    htmlFor="machine_type_id"
                                    className="block text-md font-semibold text-gray-800"
                                >{t('MachineList.Column.MachineTypeName')}</label>
                                <select
                                    name='machine_type_id' disabled
                                    value={formMachine?.machine_type_id}
                                    className='block w-full px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40'>
                                    <option value="">{t('MachineAdd.SelectMachineType')}</option>
                                    {state.machine_types.map((machine_type) => (
                                    <option key={machine_type.id} value={machine_type.id}>{machine_type.name}</option>
                                ))}
                                </select>
                            </div>
                            <div>
                                <label
                                    htmlFor="type"
                                    className="block text-md font-semibold text-gray-800"
                                >
                                    Typ stroja
                                </label>
                                <input
                                    name='type' readOnly
                                    type="text"
                                    value={formMachine?.type}
                                    className="block w-full  px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                                />
                            </div>
                            <div>
                                <label
                                    htmlFor="serial_number"
                                    className="block text-md font-semibold text-gray-800"
                                >{t('Common.SerialNumber')}</label>
                                <input
                                    name='serial_number' readOnly
                                    type="text"
                                    value={formMachine?.serial_number}
                                    className="block w-full  px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                                />
                            </div>
                        </div>
                    </div>  
                </div>
                <div className="w-auto p-6 m-4 bg-gray-100 rounded-md shadow-md">
                    <div className="md:grid grid-cols-2 gap-2 mb-2">
                        
                        <div>
                            <label
                                htmlFor="fabrication_year"
                                className="block text-md font-semibold text-gray-800"
                            >{t('Common.FabricationYear')}</label>
                            <input
                                name='fabrication_year' readOnly
                                type="number"
                                value={formMachine?.fabrication_year}
                                className="block w-full px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                            />
                        </div>
                        <div>
                            <label
                                htmlFor="last_overhaul"
                                className="block text-md font-semibold text-gray-800"
                            >{t('Common.LastOverhaul')}</label>
                            <input 
                                name='last_overhaul' readOnly
                                type="date"
                                value={formMachine?.last_overhaul}
                                className="block w-full px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                            />
                        </div>
                        <div>
                            <label
                                htmlFor="description"
                                className="block text-md font-semibold text-gray-800"
                            >{t('Common.MachineDescription')}</label>
                            <textarea
                                name='description' readOnly
                                value={formMachine?.description}
                                className="block w-full px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                            />
                        </div> 
                        <div>
                        <label
                            htmlFor="manufacturer"
                            className="block text-md font-semibold text-gray-800 mt-2"
                        >{t('Common.Manufacturer')}</label>
                        <input
                            name='manufacturer' readOnly
                            type="text"
                            value={formMachine?.manufacturer}
                            className="block w-full  px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                        />
                    </div>
                    </div>
                </div>
                </div> 
                </div>
                 </SplitterPanel>
    <SplitterPanel className="flex flex-col align-items-center justify-content-center w-full overflow-y-auto" size={40} style={{minHeight: '110px'}}>
    <ReactTabulator
      key={formMachine?.id || "no-machine"}   // odporúčam (Tabulator občas “drží” staré data)
      onRef={(r) => (ref.current = r.current)}
      className='h-full w-full' //176px h-[calc(100vh_-_176px)]
      columns={columns}
      events={{
        tableBuilt: () => {
            const table = getTable();
            if (!table) return;
            isRestoringRef.current = true;
            const effective = getEffectiveMask(MASK_PAGE, state);
            if (effective?.type === 'user' && effective.userMask) {
                restoreChecklistDetailUserMaskToTable(table, effective.userMask, {
                    canonicalFieldOrder: CHECK_RECORD_DETAIL_COLUMN_FIELD_ORDER,
                    setColumnsVisible,
                    clearHeaderFiltersWhenEmpty: true,
                    applyColumnVisibilityFn: (tbl, jc, setVis) => {
                        const merged = mergeCheckRecordDetailColumnVisibilityFromSaved(jc);
                        setVis(merged);
                        applyCheckRecordDetailDataColumnVisibility(tbl, merged);
                    },
                });
            } else if (effective?.type === 'standard' && effective.standardMask) {
                const m = effective.standardMask;
                const jsonColumns = safeParse(m.columns, {});
                applyChecklistDetailColumnLayout(table, safeParse(m.attributes, []), CHECK_RECORD_DETAIL_COLUMN_FIELD_ORDER);
                if (jsonColumns && typeof jsonColumns === 'object') {
                    const merged = mergeCheckRecordDetailColumnVisibilityFromSaved(jsonColumns);
                    setColumnsVisible(merged);
                    applyCheckRecordDetailDataColumnVisibility(table, merged);
                }
            } else {
                applyCheckRecordDetailDataColumnVisibility(table, columnsVisible);
            }
            setTimeout(() => {
                isRestoringRef.current = false;
            }, 0);
            tableBuiltRef.current = true;
            refreshFromStart();
        },
        ...getTabulatorPersistLayoutEvents(MASK_PAGE, ref, setUserMaskFilter),
        headerFilterChanged: () => {
            if (!isRestoringRef.current) {
                captureHScroll();
                refreshFromStart();
            }
        },
        sortChanged: () => {
            if (!isRestoringRef.current) {
                captureHScroll();
                refreshFromStart();
            }
        },
        rowSelectionChanged: onSelectRow,
        renderComplete: () => restoreHScroll(),
      }}
      options={{
        height: "100%",
        layout: "fitColumns",
        rowHeight: 42,
        renderHorizontal: "virtual",
        movableColumns: true,
        printAsHtml: true,
        printRowRange: "active",
        printCopyStyle: true,
        dataLoader: true,
        dataLoaderLoading: t('Common.LoadingData'),
        dataLoaderError: t('Common.LoadFailed'),
        placeholder: t('Common.NoData'),
        progressiveLoad: "scroll",
        progressiveLoadScrollMargin: 0,
        progressiveLoadDelay: 200,
        paginationSize: pageSizePc,
        progressiveRender: true,
        progressiveRenderSize: 30,
        filterMode: "remote",
        sortMode: "remote",
        ajaxURL: "/api/checklist_all_records/paged",
        ajaxParams: () => ({}),
        ajaxRequestFunc: createDedupedAjaxRequest(buildRequestParams, tabulatorGet, inFlightRef, completedCacheRef),
        headerSortTristate: true,
        ajaxRequesting: () => {
            if (tableBuiltRef.current && !isRestoringRef.current) captureHScroll();
            getTable()?.alert?.(t('Common.LoadingData'));
            return true;
        },
        ajaxResponse: (url, params, response) => { getTable()?.clearAlert?.(); return response; },
        ajaxError: () => { getTable()?.clearAlert?.(); },
        printHeader: function () {
            const bodyHtml = ReactDOMServer.renderToStaticMarkup(
                <div className="w-full text-[11px]">
{/* 2. riadok – polia v dvoch stĺpcoch */}
                    <div className="grid grid-cols-2 gap-4 mb-2">
                        {/* Ľavý stĺpec */}
                        <div className="space-y-2">
                            <div>
                                <label className="block text-[11px] text-left font-semibold text-gray-800">{t('Ui.R67.Por_c')}</label>
                                <input
                                    type="text"
                                    readOnly
                                    value={formMachine?.id ?? ''}
                                    className="mt-1 block w-full px-2 text-[11px] bg-white border border-gray-300 rounded-md"
                                />
                            </div>
    
                            <div>
                                <label className="block text-[11px] text-left font-semibold text-gray-800">{t('Common.MachineName')}</label>
                                <input
                                    name="name"
                                    type="text"
                                    readOnly
                                    value={formMachine?.name || ''}
                                    className="mt-1 block w-full px-2 text-[11px] bg-white border border-gray-300 rounded-md"
                                />
                            </div>
                            <div className="grid grid-cols-2 gap-2">
                                <div>
                                    <label className="block text-[11px] text-left font-semibold text-gray-800">{t('MachineList.Column.MachineTypeName')}</label>
                                    <input
                                        name="machine_type_name"
                                        type="text"
                                        readOnly
                                        value={formMachine?.machine_type?.name || ''}
                                        className="mt-1 block w-full px-2 text-[11px] bg-white border border-gray-300 rounded-md"
                                    />
                                </div>
                                <div>
                                    <label className="block text-[11px] text-left font-semibold text-gray-800">
                                        Typ stroja
                                    </label>
                                    <input
                                        name="type"
                                        type="text"
                                        readOnly
                                        value={formMachine?.type || ''}
                                        className="mt-1 block w-full px-2 text-[11px] bg-white border border-gray-300 rounded-md"
                                    />
                                </div>
                            </div>
                        </div>
    
                        {/* Pravý stĺpec */}
                        <div className="space-y-2">
                            <div>
                                <label className="block text-[11px] text-left font-semibold text-gray-800">{t('Common.SerialNumber')}</label>
                                <input
                                    name="serial_number"
                                    type="text"
                                    readOnly
                                    value={formMachine?.serial_number || ''}
                                    className="mt-1 block w-full px-2 text-[11px] bg-white border border-gray-300 rounded-md"
                                />
                            </div>
    
                            <div className="grid grid-cols-2 gap-2">
                                <div>
                                    <label className="block text-[11px] text-left font-semibold text-gray-800">{t('Common.FabricationYear')}</label>
                                    <input
                                        name="fabrication_year"
                                        type="number"
                                        readOnly
                                        value={formMachine?.fabrication_year || ''}
                                        className="mt-1 block w-full px-2 text-[11px] bg-white border border-gray-300 rounded-md"
                                    />
                                </div>
                                <div>
                                    <label className="block text-[11px] text-left font-semibold text-gray-800">{t('Common.LastOverhaul')}</label>
                                    <input
                                        name="last_overhaul"
                                        type="date"
                                        readOnly
                                        value={formMachine?.last_overhaul || ''}
                                        className="mt-1 block w-full px-2 text-[11px] bg-white border border-gray-300 rounded-md"
                                    />
                                </div>
                            </div>
    
                            <div>
                                <label className="block text-[11px] text-left font-semibold text-gray-800">{t('Common.Manufacturer')}</label>
                                <input
                                    name="manufacturer"
                                    type="text"
                                    readOnly
                                    value={formMachine?.manufacturer || ''}
                                    className="mt-1 block w-full px-2 text-[11px] bg-white border border-gray-300 rounded-md"
                                />
                            </div>
                        </div>
                    </div>
    
                    {/* 3. riadok – popis cez celú šírku */}
                    <div className="mt-1">
                        <label className="block text-[11px] text-left font-semibold text-gray-800">{t('Common.MachineDescription')}</label>
                        <textarea
                            name="description"
                            readOnly
                            value={formMachine?.description || ''}
                            className="mt-1 block w-full px-2 text-[11px] bg-white border border-gray-300 rounded-md min-h-[40px]"
                        />
                    </div>
                </div>
            );
            return buildCanonicalPrintHeaderHtml({
                branding: state?.branding,
                productFallbackSrc: defaultProductLogoSrc,
                companySettingsPrint: state?.company_settings_print,
                moduleSettings: state?.module_settings,
                title: t('Print.Title.MaintenanceCheckRecordDetail'),
                printDateLabel: t('Print.DateLabel'),
                bodyHtml,
            });
        },
                printFooter: function () {
                    return buildCanonicalPrintFooterHtml({ companySettingsPrint: state?.company_settings_print });
                }
      }}/>
    </SplitterPanel>
    </Splitter>
<Dialog header={t('Common.SetMask')} visible={maskVisible} style={{ width: '70vw' }} onHide={() => setMaskVisible(false)}>
            <div className="flex flex-col">
              <p className="text-sm text-gray-600 mb-2">{t('MaintenanceTemplateList.MaskHelp')}</p>
              <div className="flex flex-wrap gap-2 mb-2">
                <button type="button" onClick={maskSelectAll} className="px-3 py-1.5 text-sm bg-zinc-200 text-zinc-900 rounded-md hover:bg-zinc-300">{t('Common.SelectAll')}</button>
                <button type="button" onClick={maskDeselectAll} className="px-3 py-1.5 text-sm bg-zinc-200 text-zinc-900 rounded-md hover:bg-zinc-300">{t('Common.DeselectAllExceptId')}</button>
              </div>
            {columns.map((item) => {
                if (!item.field || MAINTENANCE_MASK_DIALOG_SKIP_FIELDS.has(item.field)) return null;
                        return <div
                            key={item.field}
                            className="flex flex-row border border-black rounded-md p-2 m-1"
                        >
                                <MaintenanceMaskDialogCheckbox field={item.field} inputId={`mcrd-mask-${item.field}`} title={item.title || item.field} columnsVisible={columnsVisible} onChange={setMask} /><label htmlFor={`mcrd-mask-${item.field}`} className={`ml-2 ${item.field === 'id' ? '' : 'cursor-pointer'}`}>{item.title || item.field}</label>
                        </div>
                    })}
                        <button type="button" onClick={saveUserMaskColumns} className='m-1 px-4 py-2 bg-zinc-900 text-white rounded-md hover:bg-zinc-700'>{t('Common.SaveUpper')}</button>
            </div>
        </Dialog>
            </div>
            </> 
            );
} 
